<template>
    <div>
        <v-dialog value="true" persistent fullscreen hide-overlay scrollable>
            <v-card>
                <v-card-title class="pa-0">
                    <toobar @voltar="voltarParaMeusDocumentos" :titulo="getTitulo" />
                </v-card-title>

                <v-card-text class="pa-0">
                    <v-container fluid class="co-documento-novo">
                        <v-row no-gutters :style="getHeight">
                            <v-col class="formulario-documento pa-0" cols="12" sm="3">
                                <formulario-documento
                                    ref="formularioDocumentoNovo"
                                    class="ma-3 formulario"
                                    :documento="documento"
                                    @pular-adicao-signatarios="atualizarPularAdicaoSignatarios"
                                />

                                <div v-if="!ehMobile" class="d-flex justify-end pa-4 btn-continuar">
                                    <v-btn color="primary" @click="continuarOnce" :disabled="disableContinuar">
                                        Continuar
                                        <v-icon right> mdi-arrow-right </v-icon>
                                    </v-btn>
                                </div>
                            </v-col>

                            <v-col class="tabs-conteudo-wrapper" :style="getStyleBackground" cols="12" sm="9">
                                <v-tabs
                                    class="tabs"
                                    v-model="opcaoUpload"
                                    height="45px"
                                    color="primary"
                                    background-color="var(--background-400)"
                                    flat
                                    center-active
                                    centered
                                >
                                    <v-tab v-for="item in opcoesUpload" v-if="ehAcessoPermitido(item)" :key="item.titulo">
                                        <span class="tab-label">
                                            <v-icon size="15" v-if="!ehMobile">{{ item.icon }}</v-icon>
                                            <span class="titulo ml-1">{{ item.titulo }}</span>
                                        </span>
                                    </v-tab>
                                </v-tabs>
                                <v-tabs-items v-model="opcaoUpload">
                                    <v-tab-item eager>
                                        <div>
                                            <upload :pdfs="pdfs" @adicionar-pdf="adicionarPdfs" />
                                            <lista-upload class="mb-6" :pdfs="pdfs" @remover-pdf="removerPdf" />
                                            <v-btn
                                                v-if="ehMobile"
                                                color="primary"
                                                class="btn-continuar btn-mobile"
                                                @click="continuarOnce"
                                                :disabled="disableContinuar"
                                            >
                                                Continuar
                                                <v-icon right> mdi-arrow-right </v-icon>
                                            </v-btn>
                                        </div>
                                    </v-tab-item>

                                    <v-tab-item eager>
                                        <tabela-escolher-modelo
                                            :eh-selecionando-modelo="ehSelecionandoModelo"
                                            :modelos-lista="modelosLista"
                                            :paginacao="paginacaoModelos"
                                            @buscar-pagina="buscarModelos"
                                            @modelo-selecionado="atualizarModeloSelecionado"
                                        />

                                        <v-btn
                                            v-if="ehMobile"
                                            color="primary"
                                            class="btn-continuar btn-mobile"
                                            @click="continuarOnce"
                                            :disabled="disableContinuar"
                                        >
                                            Continuar
                                            <v-icon right> mdi-arrow-right </v-icon>
                                        </v-btn>
                                    </v-tab-item>
                                </v-tabs-items>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <loading-novo :dialog="carregando" :titulo="tituloCarregando" />
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import {actionTypes} from '@/commons/constants'
import Toobar from '@/views/criar-documento/components/toobar/Toobar'
import Upload from '@/views/criar-documento/novo-documento/components/documento/campos-upload/Upload'
import ListaUpload from './components/documento/campos-upload/listaUpload/ListaUpload'
import FormularioDocumento from './components/documento/campos-formulario/FormularioDocumento'
import DateTimeUtils from '@/commons/utils/DateTimeUtils'
import moment from 'moment-timezone'
import Utils from '@/commons/utils/Utils'
import RouterUtils from '@/commons/utils/RouterUtils'
import LoadingNovo from '@/commons/components/dialogs/LoadingNovo'
import TabelaEscolherModelo from './components/TabelaEscolherModelo'
import _ from 'lodash'
import {hasPermissions} from '@azinformatica/loki'

export default {
    name: 'NovoDocumento',
    components: {
        FormularioDocumento,
        ListaUpload,
        Upload,
        Toobar,
        LoadingNovo,
        TabelaEscolherModelo,
    },
    data() {
        return {
            documento: {
                nome: '',
                nomeDocOriginal: '',
                inicioVigencia: '',
                fimVigencia: '',
                inicioAssinatura: '',
                fimAssinatura: '',
                tags: [],
                pastaId: null,
                modeloId: null,
            },
            pularAdicaoSignatarios: false,
            carregando: false,
            modelosLista: [],
            modeloSelecionado: [],
            disableContinuar: false,
            pdfs: [],
            opcaoUpload: 0,
            paginacaoModelos: { page: 1, rowsPerPage: 10, numPages: 1, sortBy: 'titulo', descending: true },
            opcoesUpload: [
                { icon: 'mdi-cloud-upload', titulo: 'Carregar arquivo' },
                { icon: 'mdi-file-document', titulo: 'Modelos' },
            ],
        }
    },
    computed: {
        ...mapState(['pastaAtual', 'loki']),
        ...mapGetters(['podeCriarContratoRaiz', 'ehAdministradorOrganizacao']),
        ehMobile() {
            return this.$vuetify.breakpoint.xsOnly
        },
        ehSelecionandoModelo() {
            return this.opcaoUpload === 1
        },
        getHeight() {
            return this.ehMobile ? ' height: auto' : ' height: 100%'
        },
        getStyleBackground() {
            return this.ehMobile ? 'background: var(--background-200)' : 'background: white'
        },
        getTitulo() {
            return `Novo ${this.$tc('pt_br.documento')}`
        },
        tituloCarregando() {
            return `Aguarde um momento, gerando ${this.$tc('pt_br.documento').toLowerCase()}...`
        },
    },
    watch: {
        pdfs(val) {
            if (!this.ehSelecionandoModelo && !this.documento.nome && val.length) {
                this.documento.nome = this.pdfs[0].name.slice(0, -4)
            }
        },
        modeloSelecionado(valor) {
            if (!!valor.length && !this.documento.nome) {
                this.documento.nome = valor[0].titulo
            }
        },
        async opcaoUpload() {
            this.modeloSelecionado = []
            this.modelosLista = []
            this.limparPdfs()

            if (this.ehSelecionandoModelo) {
                await this.buscarModelos()
            }
        },
    },
    created() {
        this.validarPastaAtual()
    },
    mounted() {
        this.inicializarModeloDocumento()
    },
    methods: {
        ...mapActions([actionTypes.CRIAR_CONTRATO]),
        adicionarPdfs(files) {
            this.pdfs.push(...files)
        },
        atualizarPularAdicaoSignatarios(val) {
            this.pularAdicaoSignatarios = val
        },
        atualizarDatasISO(documento) {
            documento.inicioVigencia = DateTimeUtils.setZeroHorasISO(documento.inicioVigencia)
            documento.fimVigencia = DateTimeUtils.set23HorasISO(documento.fimVigencia)
            documento.inicioAssinatura = DateTimeUtils.setZeroHorasISO(documento.inicioAssinatura)
            documento.fimAssinatura = DateTimeUtils.set23HorasISO(documento.fimAssinatura)
        },
        atualizarModeloSelecionado(modelo) {
            this.modeloSelecionado = modelo
        },
        async buscarModelos() {
            const data = await this.$store.dispatch(actionTypes.MODELO.BUSCAR_TODOS, {
                filtros: { situacao: { value: 'ativo', default: null } },
                paginacao: this.paginacaoModelos,
            })

            this.modelosLista = data.content
            this.paginacaoModelos.numPages = data.totalPages
        },
        async buscarTamanhoMbModelo() {
            const modeloBase64 = await this.$store.dispatch(actionTypes.MODELO.BUSCAR_BASE64, { id: this.modeloSelecionado[0].id })
            let tamanhoBytes = (modeloBase64.modelo.length * 3) / 4
            const bytesPadding = modeloBase64.modelo.match(/=*$/)[0].length
            tamanhoBytes -= bytesPadding
            const tamanhoMB = tamanhoBytes / (1024 * 1024)
            return tamanhoMB
        },
        construirNomeDocOriginalModelo(tituloModelo) {
            return tituloModelo.endsWith('.pdf') ? tituloModelo : tituloModelo + '.pdf'
        },
        construirRequisicao() {
            const documento = _.clone(this.documento)
            this.atualizarDatasISO(documento)
            documento.nomeDocOriginal = this.ehSelecionandoModelo
                ? this.construirNomeDocOriginalModelo(this.modeloSelecionado[0].titulo)
                : this.pdfs[0].name

            const arquivo = new FormData()

            if (this.pdfs.length && !this.ehSelecionandoModelo) {
                this.pdfs.forEach(a => {
                    arquivo.append('arquivo', a)
                })
            }

            arquivo.append('contrato', JSON.stringify(documento))

            return arquivo
        },
        async continuarOnce() {
            this.disableContinuar = true
            setTimeout(() => {
                this.criarNovoDocumento()
            }, 500)
        },
        async criarNovoDocumento() {
            const dadosValidos = await this.validarDadosFormulario()
            if (!dadosValidos) {
                this.disableContinuar = false
                return
            }
            try {
                this.carregando = true
                if (this.ehSelecionandoModelo && !!this.modeloSelecionado.length) {
                    this.documento.modeloId = this.modeloSelecionado[0].id
                }

                this.setMensagemLoading('Salvando documento...')
                const { data } = await this.$store.dispatch(actionTypes.CRIAR_CONTRATO, this.construirRequisicao())
                this.mostrarNotificacaoSucessoDefault()

                if (this.pularAdicaoSignatarios) {
                    await this.$router.push({ name: 'detalheContrato', params: { id: data.contratoId } })
                } else {
                    let tipoDefault = this.$route.params.tipoDefault
                    await this.$router.push({ name: 'novoDocumentoSignatario', params: { id: data.contratoId, tipoDefault: tipoDefault } })
                }
            } catch (e) {
                this.disableContinuar = false
                const exceptionType = e.response.data.exception
                if (exceptionType && exceptionType.search('LimiteDocumentosAtingidoException') !== -1) {
                    this.mostrarLimitePlanoAtingido = true
                }
                await this.resetDatas()
            } finally {
                this.carregando = false
            }
        },
        ehAcessoPermitido(item) {
            const userPermissions = this.loki.user.authorities
            return item.titulo !== 'Modelos' || hasPermissions(userPermissions, ['Modelo.Visualizar'])
        },
        fecharDialogLimitePlanoAtingido() {
            this.mostrarLimitePlanoAtingido = false
        },
        inicializarModeloDocumento() {
            let criacao = moment().format('YYYY-MM-DD')
            let vencimento = moment().add(7, 'days').format('YYYY-MM-DD')
            this.documento.inicioVigencia = criacao
            this.documento.inicioAssinatura = criacao
            this.documento.fimAssinatura = vencimento

            if (this.pastaAtual.pastaId) {
                this.documento.pastaId = this.pastaAtual.pastaId
            }
        },
        limparPdfs() {
            this.pdfs = []
        },
        removerPdf(pdf) {
            const index = this.pdfs.indexOf(pdf)
            if (index > -1) {
                this.pdfs.splice(index, 1)
            }
        },
        resetDatas() {
            this.documento.inicioVigencia = moment(this.documento.inicioVigencia).format('YYYY-MM-DD')
            this.documento.fimVigencia = moment(this.documento.fimVigencia).format('YYYY-MM-DD')
            this.documento.inicioAssinatura = moment(this.documento.inicioAssinatura).format('YYYY-MM-DD')
            this.documento.fimAssinatura = moment(this.documento.fimAssinatura).format('YYYY-MM-DD')
        },
        async validarArquivoSelecionado() {
            if (this.ehSelecionandoModelo) {
                if (!this.modeloSelecionado.length) {
                    this.mostrarNotificacaoErro('Modelo não selecionado.')
                    return false
                }
                const tamanhoMbModelo = await this.buscarTamanhoMbModelo()

                if (tamanhoMbModelo > 20) {
                    this.mostrarNotificacaoErro(
                        `Modelo selecionado excede o limite de tamanho de arquivos: ${tamanhoMbModelo.toFixed(
                            0
                        )}MB. Máximo permitido: 20MB.`
                    )
                    return false
                }
            } else if (!this.pdfs || this.pdfs.length <= 0) {
                this.mostrarNotificacaoErro('Arquivo(s) não selecionado(s).')
                return false
            }

            return true
        },
        async validarDadosFormulario() {
            const validado = await this.$refs.formularioDocumentoNovo.validarFormulario()
            const datasValidas = this.validarDatasInicioFimVigencia()
            const arquivoSelecionado = await this.validarArquivoSelecionado()
            const validarDocumentoRaiz = await this.validarCriarDocumentoRaiz()
            if (!datasValidas || !validarDocumentoRaiz) {
                this.$refs.formularioDocumentoNovo.abrirOpcoesAvancadas()
            }
            return validado && datasValidas && arquivoSelecionado && validarDocumentoRaiz
        },
        validarDatasInicioFimVigencia() {
            if (!this.documento.inicioVigencia) {
                return false
            }
            if (this.documento.fimVigencia) {
                const fimVigencia = moment(this.documento.fimVigencia)
                const inicioVigencia = moment(this.documento.inicioVigencia)
                if (inicioVigencia.isAfter(fimVigencia)) {
                    this.mostrarNotificacaoErro('A data de término da vigência não pode ser anterior ao início da vigência.')
                    return false
                }
            }
            return true
        },
        async validarCriarDocumentoRaiz() {
            if (!this.podeCriarContratoRaiz && !Utils.possuiValor(this.documento.pastaId)) {
                if (this.ehAdministradorOrganizacao) {
                    this.mostrarNotificacaoErro(
                        `Não é permitido criar ${this.$tc(
                            'pt_br.documento'
                        ).toLowerCase()}s na RAIZ, selecione uma pasta ou mude a configuração.`
                    )
                } else {
                    this.mostrarNotificacaoErro(
                        `Não é permitido criar  ${this.$tc(
                            'pt_br.documento'
                        ).toLowerCase()}s na RAIZ, selecione uma pasta ou contate o Administrador da sua Organização.`
                    )
                }
                return false
            }
            return true
        },
        voltarParaMeusDocumentos() {
            RouterUtils.voltarParaMeusDocumentos(this.meusContratosBusca.filtros.formalizacao.value)
        },
    },
}
</script>

<style lang="stylus">
.co-documento-novo
    background var(--background-200) !important

    .tabs-conteudo-wrapper
        max-height calc(100vh - 50px)
        overflow-y auto

        .tabs
            .tab-label
                .titulo
                    font-size 13px

    .col-12, .col-sm-3
        padding 0

    .btn-continuar
        width 100%
        bottom 0
        z-index 999
        background var(--background-200) !important

    .btn-mobile
        position absolute
        height 60px !important

    .formulario-documento
        position relative
        height auto
        background-color var(--background-200)

        .formulario
            overflow auto
            height calc(100vh - 118px)

@media (max-width: 600px)
    .co-documento-novo
        .footer-tabela-modelos
            padding-bottom 80px

        .tabs-conteudo-wrapper
            max-height unset

        .formulario-documento
            .formulario
                height auto
</style>
